import React from 'react';
import {
  Button, ButtonToolbar, Loader, Message, Modal,
} from 'rsuite';
import { PricingAvailabilityUpdateResult } from '../../api/apiTypes';
import { downloadData } from '../../utils/downloadData';

interface ContentProps {
  response: PricingAvailabilityUpdateResult;
  onClose: () => void;
}

function Content({ response, onClose }: ContentProps): JSX.Element {
  const {
    total, updated, failed, report,
  } = response;

  function handleDownloadReport(): void {
    if (!report) {
      return;
    }

    downloadData(report, 'text/csv', 'reprice_report.csv');
  }

  return (
    <>
      <Modal.Header closeButton={false}>
        <Modal.Title>
          Total number of offers sent to marketplaces
          {' '}
          {total}
          .
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {updated > 0 && (
          <Message
            showIcon
            type="success"
            header={`Successfully repriced ${updated} offers.`}
          />
        )}
        {failed > 0 && (
          <Message
            showIcon
            type="error"
            header={`Failed to reprice ${failed} offers.`}
          />
        )}
      </Modal.Body>
      <Modal.Footer>
        <ButtonToolbar>
          {!!report && (
            <Button onClick={() => handleDownloadReport()}>
              Download report
            </Button>
          )}
          <Button appearance="primary" onClick={() => onClose()}>
            Close
          </Button>
        </ButtonToolbar>
      </Modal.Footer>
    </>
  );
}

interface Props {
  isLoading: boolean;
  response?: PricingAvailabilityUpdateResult;
  onClose: () => void;
}

export default function PricingRepriceResultDialog(
  { isLoading, response, onClose }: Props,
): JSX.Element | null {
  if (!response && !isLoading) {
    return null;
  }

  return (
    <Modal open onClose={() => onClose()}>
      {isLoading && (
        <Modal.Body>
          <Loader />
        </Modal.Body>
      )}
      {response && (
        <Content response={response} onClose={() => onClose()} />
      )}
    </Modal>
  );
}

PricingRepriceResultDialog.defaultProps = {
  response: undefined,
};
